import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-hot-toast";
import btnStyles from "../styles/Button.module.css";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styles from "../styles/Account.module.css";

export default function TermsAndConditions() {
  const history = useHistory();

  return <>
  <div className="px-3">
  <h3
        className="text-center py-4 w-100 mt-2"
        style={{
          // background: "#3B444A",
          background: "#39606e",
          color: "#F5F5F5",
          // fontFamily: "Playfair Display",
          textTransform: "uppercase",
        }}
      >
        Terms of Service
  </h3>
  {/* back button */}
  <Row className="mt-1">
    <Col xs={6} className="">
    <Button
        className={`${btnStyles.Button} ${btnStyles.Blue}`}
        onClick={() => history.goBack()}
      >
        Back
    </Button>
    </Col>
  </Row>
  <Row className="mt-1">
  <Col md={{span: 10, offset: 1}} className="">
  <h5 className="mt-5">The following terms of service (“<span className={`${styles.Bold} mb-0`}>Terms of Service</span>” or “<span className={`${styles.Bold} mb-0`}>Terms</span>) 
    govern the relationship between the user and <span className={`${styles.Bold} mb-0`}>FirstSlate Limited</span>, 
    incorporated under the laws of Ireland (CRO. Registered number [    ]), 
    with registered address [     ] (“<span className={`${styles.Bold} mb-0`}>FirstSlate</span>”,
     “<span className={`${styles.Bold} mb-0`}>us</span>”, “<span className={`${styles.Bold} mb-0`}>we</span>” 
     and <span className={`${styles.Bold}`}>our</span>), and should be read carefully in conjunction with the Privacy Policy.
  </h5>

  <h3><span className={`${styles.Bold} mt-5 mb-5`}>1.  General</span></h3>
  <h5>1.1 - <span className={`${styles.Bold}`}>FirstSlate Limited</span> shall provide, 
  via browser access, and in accordance with Clause 1.2:
  </h5>
  <h5 className="mt-3">i.	software for production managers (“<span className={`${styles.Bold} mb-0`}>Primary User</span>”) to 
  administer and budget video, television and film production 
  projects (“<span className={`${styles.Bold} `}>FirstSlate</span>”); and
  </h5>
  <h5 className="mt-3">
  ii.	software for cast, crew  (“<span className={`${styles.Bold} mb-0`}>Crew User</span>”) and Primary Users for, among other things, 
  planning, designing, scheduling, preparing and issuing call sheets, 
  crew administration and collaborating with others for production (“<span className={`${styles.Bold} mb-0`}>FirstSlate</span>”). 
  Crew Users shall be registered by production administrative 
  personnel (“<span className={`${styles.Bold} mb-0`}>Administrative User</span>”), 
  who themselves shall be registered by the Primary User.
  </h5>
  <h5 className="mt-5">
  1.2	- The Primary User, along with any Crew Users and Administrative Users (the “Users”) will access the Production Software at the 
  provided URL for any given Project.
  </h5>
  </Col>
  </Row>
      

  </div>
  </>;
}